import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=5fab8a2b&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=js&"
export * from "./merchant.vue?vue&type=script&lang=js&"
import style0 from "./merchant.vue?vue&type=style&index=0&id=5fab8a2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fab8a2b",
  null
  
)

export default component.exports